import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStatistics = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 544 512",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M527.8 288H290.5l158 158c6 6 16 6.6 22.2.7a239.5 239.5 0 0073.1-140.9 16 16 0 00-16-17.8zM512 223.2A240.6 240.6 0 00288.8 0 16 16 0 00272 16.2V240h223.8a16 16 0 0016.2-16.8zM224 288V50.7a16 16 0 00-17.8-16A239.8 239.8 0 00.2 280.4C4.4 408.5 114.7 513.6 243 512c50.4-.6 97-16.9 135.3-44 7.9-5.6 8.4-17.3 1.6-24.1L224 288z" })
});
export default SvgStatistics;
